import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AuthorizationService, ChatSettingsService, FeatureToggleService } from '@nx-fe/services';
import { SabhaChatNotificationService } from '@soti/sabha-components';
import { Observable, Subject, filter, take, takeUntil } from 'rxjs';
import { SabhaService } from '../../sabha.service';
import { DeviceChatDialogSize, SabhaInitState, SabhaState } from '../../store/reducers';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@soti/tooltip';
import { SvgIconsModule } from '@nx-fe/icons';
import { PipesModule } from '@nx-fe/pipes';
import * as fromSabhaActions from '../../store/actions';
import * as fromSabha from '../../store/selectors';
import { SabhaClientService } from '@nx-fe/sabha';
@Component({
  selector: 'xs-chat-toggle-button',
  templateUrl: './chat-toggle-button.component.html',
  styleUrl: './chat-toggle-button.component.scss',
  standalone: true,
  imports: [CommonModule, TooltipModule, SvgIconsModule, PipesModule]
})
export class ChatToggleButtonComponent implements OnInit, AfterViewInit, OnDestroy {

  readonly MAX_ITEMS = 99;

  showChatPopup: boolean;
  userChatAccess: boolean;
  chatSupportEnabled: boolean;
  chatToggleEnabled: boolean;
  chatToolTip: string;
  unreadChatNotifications$: Observable<number>;
  private onDestroy$ = new Subject<void>();

  constructor(
    @Inject('LOCALSTORAGE') private localStorage: Storage,
    private store: Store<SabhaState>,
    private authorizationService: AuthorizationService,
    private chatSettingService: ChatSettingsService,
    private featureToggleService: FeatureToggleService,
    private chatNotifications: SabhaChatNotificationService,
    private sabhaService: SabhaClientService) { }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngAfterViewInit(): void {
    this.store.select(fromSabha.getSabhaInitState).pipe(
      takeUntil(this.onDestroy$),
      filter(state => state === SabhaInitState.Completed),
      take(1))
      .subscribe(_ => this.store.dispatch(new fromSabhaActions.LoadOnboardingSettingsAction()));
  }

  ngOnInit(): void {
    this.userChatAccess = this.authorizationService.isAllowed('AccessChat');
    this.chatSettingService.isEnabled.then(isEnabled => {
      this.chatSupportEnabled = isEnabled;
    });
    this.chatToggleEnabled = this.featureToggleService.isEnabled('Sabha');
    this.unreadChatNotifications$ = this.chatNotifications.notitificationCount$;
    this.showChatPopup = this.localStorage.getItem('chatToggle') === 'true';
    this.chatToolTip = this.showChatPopup ? 'navbar-hide-chat-tooltip' : 'navbar-show-chat-tooltip';
    this.sabhaService
      .getToggleChatPopup$()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(val => {
        this.showChatPopup = val;
        this.chatToolTip = this.showChatPopup ? 'navbar-hide-chat-tooltip' : 'navbar-show-chat-tooltip';
      });
  }

  toggleChatView() {
    if (this.showChatPopup) {
      this.sabhaService.hideChatPopup();
    } else {
      this.sabhaService.showChatPopupOnPreviousState();
    } 
  }
}
